import "pages/Dashboard/Panel.scss";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import { Link } from "react-router-dom";

function Panel({ title, id, icon, children, showAllPath, linkLabel, hasContentBackground }) {
  return (
    <div className={ `panel ${ id ? 'panel--' + id : '' }` }>
      <div className={ 'panel__title' }>
        <Link to={ showAllPath }>
          <TitleWithIcon title={ title } headingSize={ 'small' }>
            { icon }
          </TitleWithIcon>
        </Link>

        <div className={ 'margin-left-extra-small' }>
          <Link to={ showAllPath } className={ 'underline' }>
            { linkLabel }
          </Link>
        </div>
      </div>

      <div className={ `${ hasContentBackground ? 'panel__content' : '' }` }>
        { children }
      </div>
    </div>
  );
}

export default Panel;
